import { render, staticRenderFns } from "./WebsiteNewUnitType.vue?vue&type=template&id=54601a96&scoped=true&"
import script from "./WebsiteNewUnitType.vue?vue&type=script&lang=js&"
export * from "./WebsiteNewUnitType.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteNewUnitType.vue?vue&type=style&index=0&id=54601a96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54601a96",
  null
  
)

export default component.exports